var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 20C8.46738 20.3044 8.71345 20.5583 9.01249 20.7352C9.31153 20.912 9.65258 21.0053 10 21.0053C10.3474 21.0053 10.6885 20.912 10.9875 20.7352C11.2866 20.5583 11.5326 20.3044 11.7 20M4 7C4 5.4087 4.63214 3.88258 5.75736 2.75736C6.88258 1.63214 8.4087 1 10 1C11.5913 1 13.1174 1.63214 14.2426 2.75736C15.3679 3.88258 16 5.4087 16 7C16 14 19 16 19 16H1C1 16 4 14 4 7Z",
    stroke: "#707A76",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.e0fc1e874c19514731ab7e076aaa4f16.svg";
export { ForwardRef as ReactComponent };